"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionsService = void 0;
const api_1 = require("../api");
const utils_1 = require("../utils");
class ConnectionsService {
    constructor(fetch) {
        this.apiVersion = api_1.apiVersion;
        /**
         * Translate types from external to Decodable.
         */
        this.translateTypesFromExternal = (requestBody) => {
            return this.fetch(`/${this.apiVersion}/external/translate-types-from-external`, { method: "POST", body: requestBody });
        };
        /**
         * Translate types to external from Decodable.
         */
        this.translateTypesToExternal = (requestBody) => {
            return this.fetch(`/${this.apiVersion}/external/translate-types-to-external`, { method: "POST", body: requestBody });
        };
        /**
         * Scan and return all matching resources in an external system.
         * @returns any A request and token issued by the control plane API for use with the data plane API.
         */
        this.getScanExternalResourcesToken = ({ connector, properties, }) => {
            const body = {
                connector,
                properties: Object.entries(properties).reduce((acc, [key, value]) => {
                    // any empty string properties should be `null` instead
                    acc[key] = value === "" ? null : value;
                    return acc;
                }, {}),
            };
            return this.fetch(`/${this.apiVersion}/external/scan-resources/token`, {
                method: "POST",
                body,
            });
        };
        /**
         * Create given resources in an external system.
         * @returns any A request and token issued by the control plane API for use with the data plane API.
         */
        this.getCreateExternalResourcesToken = (requestBody) => {
            return this.fetch(`/${this.apiVersion}/external/create-resources/token`, {
                method: "POST",
                body: requestBody,
            });
        };
        this.fetch = fetch;
    }
    getMetricsToken(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/metrics/token`, {
            method: "POST",
        });
    }
    listConnections(params = {}) {
        return this.fetch(`/${this.apiVersion}/connections?response_schema_v=v2&${(0, utils_1.toSearchParams)(params)}`);
    }
    getConnection(params) {
        const { id } = params, search = __rest(params, ["id"]);
        return this.fetch(`/${this.apiVersion}/connections/${id}?response_schema_v=v2&${(0, utils_1.toSearchParams)(search)}`);
    }
    activateConnection(params) {
        const { start_position, task_size } = params, searchParams = __rest(params, ["start_position", "task_size"]);
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/activate?response_schema_v=v2&${(0, utils_1.toSearchParams)(searchParams)}`, {
            method: "POST",
            body: { start_position, task_size },
        });
    }
    createConnection(connection, params) {
        return this.fetch(`/${this.apiVersion}/connections?response_schema_v=v2&${(0, utils_1.toSearchParams)(params)}`, {
            method: "POST",
            body: connection,
        });
    }
    deactivateConnection(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}/deactivate?response_schema_v=v2&${(0, utils_1.toSearchParams)(params)}`, { method: "POST" });
    }
    deleteConnection(id) {
        return this.fetch(`/${this.apiVersion}/connections/${id}`, {
            method: "DELETE",
        });
    }
    updateConnection(params) {
        return this.fetch(`/${this.apiVersion}/connections/${params.id}?response_schema_v=v2&`, {
            method: "PATCH",
            body: params.body,
        });
    }
    getDependencies(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetch(`/${this.apiVersion}/connections/${params.id}/dependencies`);
            [...Object.values(result.inputs), ...Object.values(result.outputs)].forEach((v) => (v.resourceType = v.resourceType.toUpperCase()));
            return result;
        });
    }
    getExistingConnectivityCheckToken(id, requestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/${this.apiVersion}/connections/${id}/connectivity-check/token`, { method: "POST", body: requestBody });
        });
    }
    getUncreatedConnectivityCheckToken(requestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/${this.apiVersion}/connectivity-check/token`, {
                method: "POST",
                body: requestBody,
            });
        });
    }
    getEventsToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetch(`/${this.apiVersion}/connections/${params.connection_id}/events/upload-ui/token`, {
                method: "POST",
                body: JSON.stringify({ events: params.events }),
            });
        });
    }
}
exports.ConnectionsService = ConnectionsService;
exports.default = ConnectionsService;
